<template>
    <div no-body > 
      <b-row>
        <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend><span class="p-2">Filter</span></b-input-group-prepend>
              <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblCompanyuser"
          responsive
          striped hover
          :items="items"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc" 
          :filter="filter"
          @filtered="onFiltered"                
          @row-clicked="selectItem"
        >
        <template v-slot:cell(nomor)="data">
          {{ (tblData.page - 1) * tblData.limit + (data.index + 1)}}
        </template>
        <template v-slot:cell(address)="data">
          {{ data.item.compaddr1 }}
          {{ data.item.compaddr2 }}
          {{ data.item.compaddr3 }}
        </template>
        </b-table>
      <b-row v-if="(tblData.total>10)">
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 15, 20, 25, 30, 40, 50]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

    </div>
</template>


<script>
import user from "../../apis/users";

export default {
  data() {
    return {
      items:[],
      fields: [
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
          },
          {
            key: "company",
            label: "Company Name",
            sortable: true
          },
          {
            key: "address",
            label: "Address",
          },
          {
            key: "PhoneNo",
            label: "Phone/Fax",
          },
      ],
      tblData: {
        page: 1,
        limit:10,
        total: 0,
        sortBy: 'company',
        sortDesc: false
      },
      filter:null
    };
  },
 props: ["holding"],  
  created: async function() {
      this.getData();
  },
  mounted() {
    // Set the initial number of items
    this.tblData.total = this.items.length;
  },

  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },

    getData: async function() {
      const companies=await user.company({holding:this.holding });
      // return companies;      
      this.items=companies;
      this.tblData.total = this.items.length;
    },
    selectItem(item,index) {
        this.$emit("click", item);
    },  
    refresh() {
      this.$refs.tblCompanyuser.refresh();
    }
  }
};
</script>
